/**
 * Esc / Cancel close a dialog; click outside does not (use with `persistent` on v-dialog).
 *
 * mixins: [
 *   persistentDialogEsc({
 *     showDialog: 'closeDialog',
 *     showDialog: { close: 'closeDialog', busy: 'isSaving' },
 *     'addFeed.dialog': 'closeAddDialog',
 *   }),
 * ]
 */
export default function persistentDialogEsc(modelToClose = {}) {
  const entries = Object.entries(modelToClose).map(([model, spec]) => {
    if (typeof spec === 'string') {
      return { model, close: spec, busy: null };
    }
    return {
      model,
      close: spec.close,
      busy: spec.busy || null,
    };
  });

  const watch = {};
  entries.forEach(({ model }) => {
    watch[model] = {
      immediate: true,
      handler() {
        this._syncDialogEscListener();
      },
    };
  });

  return {
    watch,
    beforeDestroy() {
      this._removeDialogEscListener();
    },
    methods: {
      _getDialogModelValue(model) {
        return model.split('.').reduce((obj, key) => (obj == null ? obj : obj[key]), this);
      },
      _syncDialogEscListener() {
        const anyOpen = entries.some(({ model }) => !!this._getDialogModelValue(model));
        if (anyOpen) {
          this._addDialogEscListener();
        } else {
          this._removeDialogEscListener();
        }
      },
      _addDialogEscListener() {
        if (this._dialogEscBound) return;
        this._dialogEscBound = true;
        globalThis.addEventListener('keydown', this._onDialogEscKeydown);
      },
      _removeDialogEscListener() {
        if (!this._dialogEscBound) return;
        this._dialogEscBound = false;
        globalThis.removeEventListener('keydown', this._onDialogEscKeydown);
      },
      _onDialogEscKeydown(e) {
        if (e.key !== 'Escape') return;
        for (let i = entries.length - 1; i >= 0; i -= 1) {
          const { model, close, busy } = entries[i];
          if (!this._getDialogModelValue(model)) continue;
          if (busy && this[busy]) return;
          const fn = this[close];
          if (typeof fn === 'function') {
            fn.call(this);
          }
          return;
        }
      },
    },
  };
}
